var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-290.769q62.692 0 105.962-43.269 43.269-43.27 43.269-105.962t-43.269-105.962Q542.692-589.231 480-589.231t-105.962 43.269Q330.769-502.692 330.769-440t43.269 105.962q43.27 43.269 105.962 43.269Zm0-40q-46.615 0-77.923-31.308T370.769-440q0-46.615 31.308-77.923T480-549.231q46.615 0 77.923 31.308T589.231-440q0 46.615-31.308 77.923T480-330.769ZM184.615-160Q157-160 138.5-178.5 120-197 120-224.615v-430.77Q120-683 138.5-701.5 157-720 184.615-720h118.308l74-80h206.154l74 80h118.308Q803-720 821.5-701.5 840-683 840-655.385v430.77Q840-197 821.5-178.5 803-160 775.385-160h-590.77Zm0-40h590.77q10.769 0 17.692-6.923T800-224.615v-430.77q0-10.769-6.923-17.692T775.385-680H639.538l-73.769-80H394.231l-73.769 80H184.615q-10.769 0-17.692 6.923T160-655.385v430.77q0 10.769 6.923 17.692T184.615-200ZM480-440Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8ffadaef4331fe884a6ad2a7e10c899a.svg";
export { ForwardRef as ReactComponent };